import React, { useState } from 'react';
import { databaseId, env } from '~/utils/auth/firebase-service.js';

interface DebugToolsModalProps {
  isManaged: boolean;
  onToggleManaged: () => void;
  loading?: boolean;
}

export const DebugToolsModal: React.FC<DebugToolsModalProps> = ({ isManaged, onToggleManaged, loading }) => {
  const [open, setOpen] = useState(false);

  // Match BuildInfo style
  const modalStyle: React.CSSProperties = {
    background: '#f0f0f0',
    color: '#222',
    border: '1px solid #ccc',
    borderRadius: 8,
    fontSize: '12px',
    fontFamily: 'inherit',
    minWidth: 220,
    maxWidth: 260,
    padding: 0,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    textAlign: 'center',
    zIndex: 10001,
    marginBottom: 8,
  };

  return (
    <div style={{ pointerEvents: 'auto', minWidth: 220, maxWidth: 260 }}>
      <div style={modalStyle}>
        <button
          style={{
            width: '100%',
            background: 'none',
            border: 'none',
            padding: '8px 0',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            borderBottom: open ? '1px solid #ccc' : 'none',
            color: '#222',
            borderRadius: '8px 8px 0 0',
            outline: 'none',
            fontFamily: 'inherit',
          }}
          onClick={() => setOpen(!open)}
        >
          Debug Tools {open ? '▲' : '▼'}
        </button>
        {open && (
          <div style={{ padding: 10 }}>
            <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center' }}>
              <span style={{ fontWeight: 500, fontSize: 12, color: '#222' }}>Toggle Managed Mode</span>
              <label style={{ display: 'inline-block', position: 'relative', width: 36, height: 18 }}>
                <input
                  type="checkbox"
                  checked={isManaged}
                  onChange={onToggleManaged}
                  style={{ opacity: 0, width: 0, height: 0 }}
                />
                <input
                  type="checkbox"
                  checked={isManaged}
                  onChange={onToggleManaged}
                  style={{ opacity: 0, width: 0, height: 0 }}
                  disabled={loading}
                />
                <span style={{
                  position: 'absolute',
                  cursor: 'pointer',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: isManaged ? '#4cd964' : '#ccc',
                  borderRadius: 18,
                  transition: 'background 0.2s',
                  boxShadow: isManaged ? '0 0 2px #4cd964' : 'none',
                }}></span>
                <span style={{
                  position: 'absolute',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: isManaged ? '#4cd964' : '#ccc',
                  borderRadius: 18,
                  transition: 'background 0.2s',
                  boxShadow: isManaged ? '0 0 2px #4cd964' : 'none',
                  opacity: loading ? 0.6 : 1,
                }}></span>
                {loading && (
                  <div style={{ fontSize: 11, color: '#888', marginTop: 6 }}>Loading…</div>
                )}
                <span style={{
                  position: 'absolute',
                  left: isManaged ? 18 : 2,
                  top: 2,
                  width: 14,
                  height: 14,
                  background: '#fff',
                  borderRadius: '50%',
                  transition: 'left 0.2s',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
                }}></span>
              </label>
            </div>
            <div style={{ marginBottom: 8, fontSize: 12, color: '#444', textAlign: 'left' }}>
              <div><strong>Database:</strong> {databaseId}</div>
              <div><strong>Environment:</strong> {env}</div>
            </div>
            {/* Add more debug tools here as needed */}
          </div>
        )}
      </div>
    </div>
  );
};
